// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Setup__codeFrame___L6Jr9 {
    overflow: auto;
    display: flex;
    flex-grow: 1;
    gap: 3.2rem;

    height: 7.35rem;

    border: 0.1rem solid var(--color-bg-border);
    border-radius: 0.4rem;
}

.Setup__codeFrameTextHeader___CAjOG {
    padding: 1.6rem;
}

.Setup__fullWidth___dcpiK .Setup__select___houjE {
    width: 23.8rem;
}

.Setup__codeFrameTextHeaderIndex___yuGrV {
    width: 5.2rem;
    line-height: 1.6rem;
}

.Setup__codeFrameTextHeaderText___idV7v {
    line-height: 1.6rem;
    white-space: pre;
}

.Setup__codeFrameBinaryHeader___jS_Yk,
.Setup__codeFrameTraceHeaders___oaVZ4 {
    width: 100%;
}

.Setup__choiceGroupHeaders___gHiMB {
    display: grid;
    grid-template-columns: 33% auto 33% auto 33%;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Setup__codeFrameTextHeader___CAjOG .Table-ContentCell {
    line-height: 1.58rem;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Setup__radioLabel___Srv4J .Radio-Label {
    font-size: var(--size-text-s);
}

.Setup__checkboxLabel___jkRMq {
    display: flex;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Setup__checkboxLabel___jkRMq .Checkbox-Label {
    font-size: var(--size-text-s);
}

.Setup__checkboxContainer___CA9pt {
    width: 100%;
}

.Setup__fullWidth___dcpiK {
    width: 100%;
}

.Setup__halfWidth___XadeH {
    width: 50%;
}

.Setup__valueContainer___hoVBn .Setup__tableSelector___yL9h7 {
    width: 20rem;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Setup__valueContainer___hoVBn .Setup__tableSelector___yL9h7 .Select-Delimiter {
    background-color: transparent;
}

.Setup__containerFields___RwHyc {
    display: flex;
    justify-content: flex-end;
    width: 100%;
}

.Setup__codeBinaryHeaderTable___YmRW1 {
    flex-direction: column;
    flex-grow: 1;
}

.Setup__rowWrapper___wo523 {
    display: flex;
    gap: 1rem;
    padding-bottom: 2.4rem;
}

.Setup__unitsTitle___rymI7 {
    white-space: nowrap;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Setup__tableContainer___XrYIk .TableHeader-Row .TableCell {
    background-color: var(--color-control-bg-ghost);
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Setup__informerContainer___EFWTl .Setup__informer___UeKDG .Text {
    margin-top: 1.6rem;
    font-size: var(--size-text-s);
}

.Setup__informerContainer___EFWTl {
    width: 30rem;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Setup__tableContainer___XrYIk .TableHeader-Row .TableCell_isHeader {
    text-transform: none;
}

.Setup__previewLine___QCuFY {
    display: flex;
}

.Setup__textPadding___dhE9s {
    padding-bottom: 0.8rem;
}

.Setup__negativeZ___gy8BB {
    padding-bottom: 0.8rem;
}

.Setup__negativeTwt___d72EO {
    padding-bottom: 2.4rem;
}

.Setup__setupContainer___MJczb {
    display: flex;

    height: 100%;
    padding-top: 2.4rem;
    padding-right: 1.2rem;
    padding-left: 1.2rem;
}

.Setup__importTextWrapper___rGH9H {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    width: 50%;
    padding-left: 1.2rem;
}

.Setup__importText___TJe2A {
    padding-bottom: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/MasterImport/MarkersImport/Setup/Setup.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,WAAW;;IAEX,eAAe;;IAEf,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,4CAA4C;AAChD;;AAEA,uEAAuE;AACvE;IACI,oBAAoB;AACxB;;AAEA,uEAAuE;AACvE;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA,uEAAuE;AACvE;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA,uEAAuE;AACvE;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uEAAuE;AACvE;IACI,+CAA+C;AACnD;;AAEA,uEAAuE;AACvE;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA,uEAAuE;AACvE;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;;IAEb,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;;IAEZ,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".codeFrame {\n    overflow: auto;\n    display: flex;\n    flex-grow: 1;\n    gap: 3.2rem;\n\n    height: 7.35rem;\n\n    border: 0.1rem solid var(--color-bg-border);\n    border-radius: 0.4rem;\n}\n\n.codeFrameTextHeader {\n    padding: 1.6rem;\n}\n\n.fullWidth .select {\n    width: 23.8rem;\n}\n\n.codeFrameTextHeaderIndex {\n    width: 5.2rem;\n    line-height: 1.6rem;\n}\n\n.codeFrameTextHeaderText {\n    line-height: 1.6rem;\n    white-space: pre;\n}\n\n.codeFrameBinaryHeader,\n.codeFrameTraceHeaders {\n    width: 100%;\n}\n\n.choiceGroupHeaders {\n    display: grid;\n    grid-template-columns: 33% auto 33% auto 33%;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.codeFrameTextHeader :global(.Table-ContentCell) {\n    line-height: 1.58rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.radioLabel :global(.Radio-Label) {\n    font-size: var(--size-text-s);\n}\n\n.checkboxLabel {\n    display: flex;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.checkboxLabel :global(.Checkbox-Label) {\n    font-size: var(--size-text-s);\n}\n\n.checkboxContainer {\n    width: 100%;\n}\n\n.fullWidth {\n    width: 100%;\n}\n\n.halfWidth {\n    width: 50%;\n}\n\n.valueContainer .tableSelector {\n    width: 20rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.valueContainer .tableSelector :global(.Select-Delimiter) {\n    background-color: transparent;\n}\n\n.containerFields {\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n}\n\n.codeBinaryHeaderTable {\n    flex-direction: column;\n    flex-grow: 1;\n}\n\n.rowWrapper {\n    display: flex;\n    gap: 1rem;\n    padding-bottom: 2.4rem;\n}\n\n.unitsTitle {\n    white-space: nowrap;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.tableContainer :global(.TableHeader-Row .TableCell) {\n    background-color: var(--color-control-bg-ghost);\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.informerContainer .informer :global(.Text) {\n    margin-top: 1.6rem;\n    font-size: var(--size-text-s);\n}\n\n.informerContainer {\n    width: 30rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.tableContainer :global(.TableHeader-Row .TableCell_isHeader) {\n    text-transform: none;\n}\n\n.previewLine {\n    display: flex;\n}\n\n.textPadding {\n    padding-bottom: 0.8rem;\n}\n\n.negativeZ {\n    padding-bottom: 0.8rem;\n}\n\n.negativeTwt {\n    padding-bottom: 2.4rem;\n}\n\n.setupContainer {\n    display: flex;\n\n    height: 100%;\n    padding-top: 2.4rem;\n    padding-right: 1.2rem;\n    padding-left: 1.2rem;\n}\n\n.importTextWrapper {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n\n    width: 50%;\n    padding-left: 1.2rem;\n}\n\n.importText {\n    padding-bottom: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"codeFrame": `Setup__codeFrame___L6Jr9`,
	"codeFrameTextHeader": `Setup__codeFrameTextHeader___CAjOG`,
	"fullWidth": `Setup__fullWidth___dcpiK`,
	"select": `Setup__select___houjE`,
	"codeFrameTextHeaderIndex": `Setup__codeFrameTextHeaderIndex___yuGrV`,
	"codeFrameTextHeaderText": `Setup__codeFrameTextHeaderText___idV7v`,
	"codeFrameBinaryHeader": `Setup__codeFrameBinaryHeader___jS_Yk`,
	"codeFrameTraceHeaders": `Setup__codeFrameTraceHeaders___oaVZ4`,
	"choiceGroupHeaders": `Setup__choiceGroupHeaders___gHiMB`,
	"radioLabel": `Setup__radioLabel___Srv4J`,
	"checkboxLabel": `Setup__checkboxLabel___jkRMq`,
	"checkboxContainer": `Setup__checkboxContainer___CA9pt`,
	"halfWidth": `Setup__halfWidth___XadeH`,
	"valueContainer": `Setup__valueContainer___hoVBn`,
	"tableSelector": `Setup__tableSelector___yL9h7`,
	"containerFields": `Setup__containerFields___RwHyc`,
	"codeBinaryHeaderTable": `Setup__codeBinaryHeaderTable___YmRW1`,
	"rowWrapper": `Setup__rowWrapper___wo523`,
	"unitsTitle": `Setup__unitsTitle___rymI7`,
	"tableContainer": `Setup__tableContainer___XrYIk`,
	"informerContainer": `Setup__informerContainer___EFWTl`,
	"informer": `Setup__informer___UeKDG`,
	"previewLine": `Setup__previewLine___QCuFY`,
	"textPadding": `Setup__textPadding___dhE9s`,
	"negativeZ": `Setup__negativeZ___gy8BB`,
	"negativeTwt": `Setup__negativeTwt___d72EO`,
	"setupContainer": `Setup__setupContainer___MJczb`,
	"importTextWrapper": `Setup__importTextWrapper___rGH9H`,
	"importText": `Setup__importText___TJe2A`
};
export default ___CSS_LOADER_EXPORT___;
